import strings from 'strings';
import { EntityType } from 'UI/constants/entityTypes';

export const getInventoryDetailsLabel = ({ entity }) => {
  if (entity === EntityType.Company) {
    return strings.map.inventory.popover.recruiterLabel;
  }

  return strings.map.inventory.popover.industrySpecialityLabel;
};
